import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Separator,
} from "@pushpress/pushpress-ui";
import { CircleChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useInstalledApps } from "../../../apis/appStore.hooks";
import { defaultToastOptions } from "../../../utils/misc";

const InviteLinkCard = ({ text, link }: { text: string; link: string }) => {
  return (
    <Link
      className="tw-p-6 tw-border-gray-200 tw-border tw-rounded-lg tw-text-left tw-flex tw-flex-col hover:tw-shadow-md tw-transition-shadow tw-text-inherit tw-no-underline hover:tw-no-underline hover:tw-text-inherit"
      to={link}
    >
      <div className="tw-flex tw-justify-between tw-items-center">
        <h3 className="tw-text-base tw-text-lg tw-font-medium">{text}</h3>
        <CircleChevronRight className="tw-text-gray-600 tw-w-10 tw-h-10 tw-stroke-1" />
      </div>
    </Link>
  );
};

export interface InvitationModalProps {
  event: {
    name: string;
    id: string;
  };
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const InvitationModal = ({
  event: { name: eventName, id: eventId },
  open,
  onOpenChange,
}: InvitationModalProps) => {
  const { data, status, error } = useInstalledApps({
    "fields.eventInvitationUi": true,
  });

  if (status === "loading") {
    return null;
  }
  if (status === "error") {
    console.error({ error }, "Unable to load installed apps");
    toast.error(
      "Unable to load installed apps, please try refreshing the page",
      defaultToastOptions,
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="tw-w-full tw-max-h-[50vh] tw-overflow-y-auto"
        align="center"
        aria-describedby="invite-members-modal"
      >
        <DialogHeader className="tw-sr-only">
          <DialogTitle>Invite people to {eventName}</DialogTitle>
        </DialogHeader>
        <div className="tw-p-3 tw-flex tw-flex-col tw-gap-4">
          <p className="tw-text-xl">Select people to invite</p>
          <Separator />
          <div className="tw-grid tw-grid-cols-1 tw-gap-4">
            <InviteLinkCard
              text="People list"
              link={`/people/members?banner=event&event_id=${eventId}`}
            />
            {data?.map((app) => (
              <InviteLinkCard
                key={app.sys.id}
                text={app.fields.name}
                link={`/app/${app.fields.slug}?banner=event&event_id=${eventId}`}
              />
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
